<mat-form-field
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full"
  (click)="edit()"
  (focus)="edit()"
>
  <mat-label>
    <span
      class="block text-ellipsis overflow-hidden pointer-events-auto"
      [matTooltip]="fieldDef.label"
      tooltipIfEllipsis
    >
      {{ fieldDef.label }}
    </span>
  </mat-label>
  <div class="w-full">
    <input
      #inputControl
      matInput
      [ngClass]="{ readonly: readonly }"
      type="text"
      [ngModel]="editing || fieldDef.meta?.value_hidden ? value : (value | formatNumber: precision : fieldDef)"
      type="text"
      (ngModelChange)="value = $event"
      (keyup.enter)="onBlur($event)"
      (blur)="onBlur($event)"
      [disabled]="isDisabled"
      [class.blurred]="fieldDef.meta?.value_hidden && !editing"
    />
  </div>
</mat-form-field>
